/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedTitle_buyPage = {
    readonly meta: {
        readonly header: string | null;
    } | null;
    readonly " $refType": "BuySharedTitle_buyPage";
};
export type BuySharedTitle_buyPage$data = BuySharedTitle_buyPage;
export type BuySharedTitle_buyPage$key = {
    readonly " $data"?: BuySharedTitle_buyPage$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedTitle_buyPage">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedTitle_buyPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'ac579f5f8cd87e18c4f3dceb5683cbb5';
export default node;
